import { Fragment } from 'react';

const createConstants = (...constants) => constants.reduce(
  (result, key) => ({
    ...result,
    [key]: key
  }),
  {}
);

const isFragment = (fragment) => (fragment == null ? void 0 : fragment.type) === Fragment || fragment === Fragment;

const mapKeysToVariants = (map, prop) => Object.keys(map).reduce((acc, key) => {
  let newProp = {};
  if (typeof prop === "string") {
    newProp = { [key]: { [prop.toString()]: `$${String(key)}` } };
  } else {
    newProp = { [key]: prop(key) };
  }
  return {
    ...acc,
    ...newProp
  };
}, {});

export { createConstants, isFragment, mapKeysToVariants };
//# sourceMappingURL=module.js.map
